import { encrypt } from '@/common/securityUtils';
import { useCan } from '@/components/can/Can';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { referralReportQueries } from '@/services/dashboard/referralReports/referralReports.queries';
import { ReferralUserType } from '@/services/dashboard/referralReports/referralReports.types';

export const useReferralAnalytics = (userType: ReferralUserType) => {
  const userTypeId = encrypt(userType === ReferralUserType.Customer ? '3' : '6');
  const canReadAnalytics = useCan({ allOf: [PERMS.customerPoint.referral.analytics] });

  const { data, isLoading } = useQuery({
    ...referralReportQueries.analytics({ userTypeId }),
    enabled: Boolean(userTypeId) && canReadAnalytics,
  });

  return {
    referralAnalytics: data?.data,
    isLoading,
  };
};
